import React from "react";
import PropTypes from "prop-types";
import "../theme/styles.css";
import { withStyles } from "@material-ui/core/styles";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import NavBar from "../components/NavBar";
import Footer from "../components/Footer";

const styles = theme => ({
  root: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2
  },
  textField: {
    flex: 1,
    marginTop: theme.spacing.unit,
    marginBottom: 0
  },
  button: {
    marginTop: theme.spacing.unit * 2
  }
});

const AppContainer = props => {
  const { children, showNav, showHeader, showFooter } = props;
  return (
    <div className="contentPage">
      {showNav ? <NavBar forDetailer /> : null}
      {showHeader ? (
        <img
          src={require("../images/logo_text_mcw.png")}
          className="textLogo"
          alt="Mucky Duck"
        />
      ) : null}
      <article>{children}</article>
      {showFooter ? <Footer /> : null}
    </div>
  );
};

function waveSVG(props) {
  const { color } = props;
  return (
    <svg
      className="wave"
      width="100%"
      height="50px"
      preserveAspectRatio="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1920 75"
    >
      <defs>
        <style>
          {`.a {
              fill: none;
            }
    
            .b {
              clip-path: url(#a);
            }
    
            .c,
            .d {
              fill: ${color};
            }
    
            .d {
              opacity: 0.5;
              isolation: isolate;
            }`}
        </style>
        <clipPath id="a">
          <rect className="a" width="1920" height="75" />
        </clipPath>
      </defs>
      <title>wave</title>
      <g className="b">
        <path
          className="c"
          d="M1963,327H-105V65A2647.49,2647.49,0,0,1,431,19c217.7,3.5,239.6,30.8,470,36,297.3,6.7,367.5-36.2,642-28a2511.41,2511.41,0,0,1,420,48"
        />
      </g>
      <g className="b">
        <path
          className="d"
          d="M-127,404H1963V44c-140.1-28-343.3-46.7-566,22-75.5,23.3-118.5,45.9-162,64-48.6,20.2-404.7,128-784,0C355.2,97.7,341.6,78.3,235,50,86.6,10.6-41.8,6.9-127,10"
        />
      </g>
      <g className="b">
        <path
          className="d"
          d="M1979,462-155,446V106C251.8,20.2,576.6,15.9,805,30c167.4,10.3,322.3,32.9,680,56,207,13.4,378,20.3,494,24"
        />
      </g>
      <g className="b">
        <path
          className="d"
          d="M1998,484H-243V100c445.8,26.8,794.2-4.1,1035-39,141-20.4,231.1-40.1,378-45,349.6-11.6,636.7,73.8,828,150"
        />
      </g>
    </svg>
  );
}
waveSVG.propTypes = {
  color: PropTypes.string
};
waveSVG.defaultProps = {
  color: "#dddddd"
};

AppContainer.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  showNav: PropTypes.bool,
  showHeader: PropTypes.bool,
  showFooter: PropTypes.bool
};
AppContainer.defaultProps = {
  children: null,
  showNav: true,
  showHeader: true,
  showFooter: true
};

export default withStyles(styles)(AppContainer);



// WEBPACK FOOTER //
// ./src/screens/AppContainer.js